import { type CSSProperties, type ReactNode } from 'react';

export interface MeasurementSectionProps {
    title: string;
    children: ReactNode;
    groupColor?: string;
}

export function MeasurementSection({ title, children, groupColor }: MeasurementSectionProps) {
    return (
        // Tailwind can't parse plain text in class names, we define a style property
        // that will exist at runtime and use it in tailwind class names
        // Once defined here, --group-color property exists for every child in the hierarchy
        <div style={{ '--group-color': groupColor ?? 'var(--color-primary)' } as CSSProperties}>
            <div className="flex items-center w-full px-2 py-2 gap-2">
                <div className="text-sm font-semibold text-(--group-color)">{title}</div>
                <span className="flex-1 border-b border-(--group-color) h-0.5"></span>
            </div>
            <div className="pb-2">{children}</div>
        </div>
    );
}
